<template>
    <div class="slider-item slider-item--top-1">
        <h2 ref="title" class="slider-item__title">{{ title }}</h2>
        <div class="slider-item__wrapper">
            <div ref="itemIcon" class="slider-item__icon">
                <img
                    :src="`/ressources/logged/img/illustrations/recap2024/slsy-${icon}.svg`"
                    alt="icon"
                    width="72"
                />
                <img
                    src="/ressources/logged/img/illustrations/recap2024/expression.svg"
                    alt="expression"
                    class="slider-item__icon-expression"
                    width="20"
                />
            </div>
            <div ref="itemValues" class="slider-item__info">
                <p class="slider-item__value">{{ value }}</p>
                <p class="slider-item__label">{{ label }}</p>
            </div>
        </div>
    </div>
</template>
<script>
import anime from 'animejs';

export default {
    name: 'Top1Slide',
    props: {
        title: {
            type: String,
            required: true,
        },
        icon: {
            type: String,
            required: true,
        },
        value: {
            type: String,
            required: true,
        },
        label: {
            type: String,
            required: true,
        },
        isActive: {
            type: Boolean,
            default: false,
        },
    },
    watch: {
        isActive(value) {
            if (value) {
                const animatedTimeline = anime.timeline({
                    delay: 300,
                });

                animatedTimeline
                    .add({
                        targets: this.$refs.title,
                        opacity: [0, 1],
                    })
                    .add(
                        {
                            targets: this.$refs.itemIcon,
                            scale: [0, 1],
                            opacity: [0, 1],
                        },
                        '-=300',
                    )
                    .add(
                        {
                            targets: this.$refs.itemValues,
                            scale: [0, 1],
                            opacity: [0, 1],
                        },
                        '-=600',
                    );
            } else {
                this.$refs.title.removeAttribute('style');
                this.$refs.itemIcon.removeAttribute('style');
                this.$refs.itemValues.removeAttribute('style');
            }
        },
    },
};
</script>
<style lang="scss" scoped>
.slider-item {
    &.slider-item--top-1 {
        align-items: flex-start;
        justify-content: flex-start;
    }

    &__title {
        color: var(--colors-common-text-primary-default);
        font-family: Patron, sans-serif;
        font-size: 24px;
        font-weight: 700;
        line-height: 26px;
        margin: 0;
    }

    &__wrapper {
        align-items: center;
        display: flex;
        flex: 1;
        flex-direction: column;
        gap: 32px;
        justify-content: center;
        width: 100%;
    }

    &__icon {
        opacity: 0;
        position: relative;

        &-expression {
            bottom: calc(100% - 1px);
            left: 100%;
            position: absolute;
        }
    }

    &__info {
        opacity: 0;
    }

    &__value {
        color: var(--colors-sellsy-brand-primary-20);
        font-family: Patron, sans-serif;
        font-size: 48px;
        font-weight: 400;
        line-height: 52px;
        margin: 0 0 8px;
        text-align: center;
        backface-visibility: visible;
    }

    &__label {
        color: var(--colors-sellsy-brand-primary-10);
        font-family: Patron, sans-serif;
        font-size: 17px;
        font-weight: 400;
        line-height: 22px;
        margin: 0;
        text-align: center;
    }
}
</style>
